import React, { useEffect } from 'react';
import './CoinCard.css';
import { useNavigate } from 'react-router-dom';
import { getBackgroundByCondition } from '../funcs/getBackgroundByCondition';

const formatLargeNumber = (num) => {
  if (num >= 1e9) return `${(num / 1e9).toFixed(1).replace(/\.0$/, '')}KK`;
  if (num >= 1e6) return `${(num / 1e6).toFixed(1).replace(/\.0$/, '')}K`;
  return num.toString();
};

const timeToMinutes = (time) => {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

const getUrlsSpot = (spotExhangeName, tokenName) => {
  if (spotExhangeName === 'mexc') return `https://www.mexc.com/ru-RU/exchange/${tokenName}_USDT`;
  if (spotExhangeName === 'gate') return `https://www.gate.io/ru/trade/${tokenName}_USDT`;
  if (spotExhangeName === 'bybit') return `https://www.bybit.com/ru-RU/trade/spot/${tokenName}/USDT`;
  if (spotExhangeName === 'htx') return `https://www.htx.com/ru-ru/trade/${tokenName.toLowerCase()}_usdt?type=spot`;
  if (spotExhangeName === 'bingx') return `https://bingx.com/ru-ru/spot/${tokenName}USDT/`;
  if (spotExhangeName === 'bitget') return `https://www.bitget.com/ru/spot/${tokenName}USDT?type=spot`;
  if (spotExhangeName === 'binance') return `https://www.binance.com/ru/trade/${tokenName}_USDT?type=spot`;
  if (spotExhangeName === 'lbank') return `https://www.lbank.com/ru/trade/${tokenName.toLowerCase()}_usdt`;
  if (spotExhangeName === 'ourbit') return `https://www.ourbit.com/ru-RU/exchange/${tokenName}_USDT`;
  if (spotExhangeName === 'kucoin') return `https://www.kucoin.com/ru/trade/${tokenName}-USDT`;
  return '#';
};

const getUrlsFutures = (futuresExhangeName, tokenName) => {
  if (futuresExhangeName === 'mexc') return `https://futures.mexc.com/ru-RU/exchange/${tokenName}_USDT`;
  if (futuresExhangeName === 'gate') return `https://www.gate.io/ru/futures/USDT/${tokenName}_USDT`;
  if (futuresExhangeName === 'bybit') return `https://www.bybit.com/trade/usdt/${tokenName}USDT`;
  if (futuresExhangeName === 'htx') return `https://www.htx.com/ru-ru/futures/linear_swap/exchange#contract_code=${tokenName}-USDT&contract_type=swap&type=isolated`;
  if (futuresExhangeName === 'bingx') return `https://swap.bingx.com/ru-ru/${tokenName}-USDT`;
  if (futuresExhangeName === 'bitget') return `https://www.bitget.com/ru/futures/usdt/${tokenName}USDT`;
  if (futuresExhangeName === 'binance') return `https://www.binance.com/ru/futures/${tokenName}USDT`;
  if (futuresExhangeName === 'lbank') return `https://www.lbank.com/ru/futures/${tokenName.toLowerCase()}usdt`;
  if (futuresExhangeName === 'ourbit') return `https://futures.ourbit.com/ru-RU/exchange/${tokenName}_USDT?type=linear_swap`;
  if (futuresExhangeName === 'kucoin') return `https://www.kucoin.com/ru/trade/futures/${tokenName}USDTM`;
  return '#';
};

// Предзагрузка иконок (все имена — нижним регистром)
const exchanges = ['mexc', 'gate', 'bybit', 'htx', 'bingx', 'bitget', 'binance', 'lbank', 'ourbit', 'kucoin'];
const preloadImages = () => {
  exchanges.forEach((exchange) => {
    const img = new Image();
    img.src = `/images/${exchange}_icon.png`;
  });
};

const CoinCard = ({ coin }) => {
  const navigate = useNavigate();

  useEffect(() => {
    preloadImages();
  }, []);

  // Новый переход на /pair-analysis/:config
  const handleHistoryClick = () => {
    const token = (coin.tokenName || 'ETH').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const buyType = coin.spotExhangeName ? 'spot' : 'futures';
    const buyExchange = (coin.spotExhangeName || coin.futuresExchange1 || 'bingx').toLowerCase();
    const sellType = 'futures';
    const sellExchange = (coin.futuresExhangeName || coin.futuresExchange2 || 'bingx').toLowerCase();

    const urlKey = `${token}-${buyExchange}_${buyType}-${sellExchange}_${sellType}`;
    navigate(`/pair-analysis/${urlKey}`);
    // если нужна новая вкладка: window.open(`/pair-analysis/${urlKey}`, '_blank');
  };

  const leftExchangeIcon = (coin.spotExhangeName || coin.futuresExchange1 || '').toLowerCase();
  const rightExchangeIcon = (coin.futuresExhangeName || coin.futuresExchange2 || '').toLowerCase();

  return (
    <div className="coin-card">
      <div className="coin-card_header" style={{ backgroundColor: getBackgroundByCondition(coin.profit) }}>
        <span>{coin.tokenName}</span>
        <div>
          <span className="profit-description">Профит:</span>
          <span className="profit">{coin.profit && +parseFloat(coin.profit).toFixed(2)} %</span>
        </div>
      </div>

      <div className="coin-card-container">
        <div className="coin-card-item">
          <span className="coin-card-item_description">Биржа</span>
          <div className="coin-card-item-exchange">
            <img
              className="coin-card-item_icon"
              src={`/images/${leftExchangeIcon}_icon.png`}
              alt="pic"
            />
            <span className="coin-card-item_value">
              {(coin.spotExhangeName?.toUpperCase()) || (coin.futuresExchange1 ? coin.futuresExchange1.toUpperCase() : '')}
            </span>
          </div>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">Цена</span>
          <span className="coin-card-item_value">{(coin.spotPrice || coin.futures1BuyPrice)}</span>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">Биржа</span>
          <div className="coin-card-item-exchange">
            <img
              className="coin-card-item_icon"
              src={`/images/${rightExchangeIcon}_icon.png`}
              alt="pic"
            />
            <span className="coin-card-item_value">
              {(coin.futuresExhangeName?.toUpperCase() || coin.futuresExchange2?.toUpperCase())}
            </span>
          </div>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">Цена</span>
          <span className="coin-card-item_value">{(coin.futuresPrice || coin.futures2SellPrice)}</span>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">{coin.volumeInDollars ? 'Объем в $' : 'Фандинг'}</span>
          <span className="coin-card-item_value">{coin.volumeInDollars || coin.fundingRate1}</span>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">{coin.volumeInTokens ? 'Объем в ₿' : 'Время'}</span>
          <span className="coin-card-item_value">
            {coin.volumeInTokens
              ? formatLargeNumber(+parseFloat(coin.volumeInTokens).toFixed(2))
              : coin.timeUntilFunding1}
          </span>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">Фандинг</span>
          <span className="coin-card-item_value">
            {coin.fundingRate ? parseFloat(coin.fundingRate).toFixed(4) : coin.fundingRate2} %
          </span>
        </div>

        <div className="coin-card-item">
          <span className="coin-card-item_description">Время</span>
          <span className="coin-card-item_value">
            {coin.timeUntilFunding ||
              (timeToMinutes(coin.timeUntilFunding1) < timeToMinutes(coin.timeUntilFunding2)
                ? coin.timeUntilFunding1
                : coin.timeUntilFunding2)}
          </span>
        </div>
      </div>

      <div className="coin-card-buttons">
        <a
          className="coin-card-buttons_buy"
          style={{ backgroundColor: getBackgroundByCondition(coin.profit) }}
          target="_blank"
          rel="noreferrer"
          href={
            coin.futuresExchange1 && coin.futuresExchange2
              ? getUrlsFutures(coin.futuresExchange1, coin.tokenName)
              : getUrlsSpot(coin.spotExhangeName, coin.tokenName)
          }
        >
          Купить
        </a>

        <button className="coin-card-buttons_history" onClick={handleHistoryClick}>
          <svg style={{scale: '0.7'}} xmlns="http://www.w3.org/2000/svg" width="44px" height="44px" viewBox="0 0 24 24" fill="none"> <path d="M21 3L14 9L10 5L3 11M4.5 21C3.67157 21 3 20.3284 3 19.5V17.5C3 16.6716 3.67157 16 4.5 16C5.32843 16 6 16.6716 6 17.5V19.5C6 20.3284 5.32843 21 4.5 21ZM11.5 21C10.6716 21 10 20.3284 10 19.5V14.5C10 13.6716 10.6716 13 11.5 13C12.3284 13 13 13.6716 13 14.5V19.5C13 20.3284 12.3284 21 11.5 21ZM18.5 21C17.6716 21 17 20.3284 17 19.5V16.5C17 15.6716 17.6716 15 18.5 15C19.3284 15 20 15.6716 20 16.5V19.5C20 20.3284 19.3284 21 18.5 21Z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> </svg>

        </button>

        <a
          className="coin-card-buttons_sell"
          target="_blank"
          rel="noreferrer"
          href={
            coin.futuresExchange1 && coin.futuresExchange2
              ? getUrlsFutures(coin.futuresExchange2, coin.tokenName)
              : getUrlsFutures(coin.futuresExhangeName, coin.tokenName)
          }
        >
          Продать
        </a>
      </div>
    </div>
  );
};

export default CoinCard;
